import { useState } from "react";
import * as Dialog from "@radix-ui/react-dialog";
import { Play, ArrowRight, X } from "lucide-react";
import { Button } from "@/components/ds";
import banner from "@/assets/banners/banner-e-mais-facil.gif.asset.json";

export function AnimatedPostBanner({ preview = false }: { href?: string; preview?: boolean }) {
  const [open, setOpen] = useState(false);
  return (
    <>
      <section className="my-12 overflow-hidden rounded-lg bg-post-banner">
        <img src={banner.url} alt="É mais fácil com a Logcomex" width={1920} height={317} className="block w-full h-auto" decoding="async" />
        <div className="flex flex-wrap items-center justify-center gap-3 px-4 pb-6 pt-3">
          <Button variant="white" iconOnly aria-label="Ver vídeo" onClick={() => setOpen(true)}><Play className="h-[15px] w-[15px] fill-current" /></Button>
          <Button variant="white" iconRight={<ArrowRight />} onClick={() => { if (!preview) window.location.assign("https://logcomex.ai"); }}>Teste agora!</Button>
        </div>
      </section>
      <Dialog.Root open={open} onOpenChange={setOpen}>
        <Dialog.Portal>
          <Dialog.Overlay className="fixed inset-0 z-[100] bg-foreground/50 backdrop-blur-md" />
          <Dialog.Content aria-describedby={undefined} className="fixed left-1/2 top-1/2 z-[101] w-[calc(100%-2rem)] max-w-5xl -translate-x-1/2 -translate-y-1/2 overflow-visible rounded-lg shadow-[0_0_80px_8px_hsl(var(--primary)/0.45)]">
            <Dialog.Title className="sr-only">É mais fácil com a Logcomex</Dialog.Title>
            <Dialog.Close asChild><Button variant="white" size="sm" iconOnly aria-label="Fechar vídeo" className="absolute -right-3 -top-3 z-10"><X className="h-4 w-4" /></Button></Dialog.Close>
            <iframe className="block aspect-video w-full rounded-lg border-0" src="https://www.youtube.com/embed/DALtepsTdTQ?autoplay=1&rel=0" title="É mais fácil com a Logcomex" allow="autoplay; encrypted-media; picture-in-picture; fullscreen" allowFullScreen />
          </Dialog.Content>
        </Dialog.Portal>
      </Dialog.Root>
    </>
  );
}